/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { Spin, Checkbox, Radio } from "antd";

import { googleAds } from "appConfig";

import styles from "./subLevel2Desktop.scss";
import { formatNumber } from "../../../../services/utils";
import Footer from "./Footer";
import { NewAdsSection } from "../../NewAdsSection";
import { DiscountedAdsSection } from "../../DiscountedAdsSection";
import GoogleAd from "../../../../components/GoogleAd";
import { mapCategoryToEn } from "../../../../routes/LanguageMapper";
import { checkEmptyArray } from "../../../../services";
import AgeVerification from "../../../../components/AgeVerificationModal";
import { connect } from "react-redux";
import { selectCurrentCategories, selectCurrentModuleName, selectModules } from "../../../App/selectors";
import { useAgeVerification } from "../../../../hooks/useAgeVerification";

const SubLevel2Desktop = ({
  level,
  category,
  module,
  loading,
  onSellectAll,
  onBoxClick,
  onSearchClick,
  listKey,
  levelCount,
  isMakePage,
  categories,
  moduleName,
  modules,
  categoryLv1Ids
}) => {

  const [value, setValue] = useState('all');

  // Use unified age verification hook
  const { ageVerificationModal, shouldShowModal, forbiddAds } = useAgeVerification({
    module,
    category,
    modules,
    categories
  });

  const handleChoosenValue = (e) => {
    const val = e.target.value;
    setValue(val);

    if (val) {
      if (val === "all") {
        onSellectAll();
      } else {
        const mappedRadio = level.find(l => l.id === val);
        onBoxClick(mappedRadio);
      }
    }
  };

  const [routeLinks, setRouteLinks] = useState([]);

  useEffect(() => {
    if (categories.length > 0) {
      const categoryName = categories.find(
        c => c.name === mapCategoryToEn(category, module)
      ).displayName;

      setRouteLinks([
        { title: moduleName, link: `/${module}` },
        { title: categoryName, link: `/${module}/${category}` },
      ]);
    }
  }, [moduleName, categories, module, category]);

  // if AgeVerification state is not calculated yet, we should not render
  if (ageVerificationModal === null && (!checkEmptyArray(categories) || !checkEmptyArray(modules))) {
    return null;
  }

  // Check if age verification is required
  if (shouldShowModal) {
    return <AgeVerification />;
  }

  return (
    <div className={`child-center ${styles.container}`}>
      <div className={styles.title}>
        {isMakePage ? "Odaberite model" : "Odaberite sljedeću potkategoriju"}
      </div>
      <div className={styles.categoryContainer}>
        {loading ? (
          <Spin tip={"Učitavam..."} size="large" />
        ) : (
          <React.Fragment key={listKey}>
            <Radio.Group onChange={handleChoosenValue} value={value}>
              <Radio
                value={'all'}
                className={styles.category}
              >
                <span>{"Svi modeli"}</span>
                {levelCount ?
                  <span className={styles.count}>{formatNumber(levelCount)}</span>
                  : null
                }
              </Radio>

              {level.map((l: any) => (
                <Radio
                  defaultChecked={l.checked}
                  value={l.id}
                  key={l.id}
                  className={styles.category}
                >
                  <span>{l.name}</span>
                  {l.count ? <span className={styles.count}>{formatNumber(l.count)}</span> : null}
                </Radio>
              ))}
            </Radio.Group>
          </React.Fragment>
        )}
      </div>
      <Footer
        onSearchClick={onSearchClick}
      //categoryName={categoryName}
      //module={module}
      />
      {!forbiddAds && (
        <div style={{ marginTop: 20 }}>
          <GoogleAd
            className={styles.ads}
            config={{
              ...googleAds.subLevel.top,
              id: "googleAds.subLevel.top"
            }}
          />
        </div>
      )}

      <DiscountedAdsSection className={styles.newAdsSection} module={module} category={category} categoryLv1Ids={categoryLv1Ids} />
      <NewAdsSection className={styles.newAdsSection} module={module} category={category} categoryLv1Ids={categoryLv1Ids} />

      {!forbiddAds && (
        <GoogleAd
          className={styles.ads}
          config={{
            ...googleAds.subLevel.bottom1,
            id: "googleAds.subLevel.bottom1"

          }}
        />
      )}
    </div>
  )
};

SubLevel2Desktop.defaultProps = {
  levelCount: 0
};

export default connect(
  (state: any) => ({
    categories: selectCurrentCategories(state),
    moduleName: selectCurrentModuleName(state),
    modules: selectModules(state),
  }),
  {

  }
)((SubLevel2Desktop));







// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel2/SubLevel2Desktop/index.tsx